import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import styles from "components/upload-documents/pending-documents-list.scss";
import grid from "components/grid.scss";
import { documentPropType } from "custom-prop-types";
import { pluralize } from "utils/string-helpers";

export const PendingDocumentsList = ({ pendingDocuments }) => (
  <div>
    <div className={ styles["pending-documents-container"] }>
      <div className={ `${grid.row} ${styles["pending-titles"]}` }>
        <div className={ `${grid["col-md-8"]}` }>File name:</div>
        <div className={ `${grid["col-md-4"]}` }>Uploaded At:</div>
      </div>
      <div className={ styles["pending-documents"] }>
        { renderList(pendingDocuments) }
      </div>
    </div>
    <div className={ styles.pending }>
      <div className={ styles["number-pending"] }>
        { pluralize(pendingDocuments.length, "documents", "document") } awaiting processing
      </div>
    </div>
  </div>
);

const renderList = (pendingDocuments) => (
  pendingDocuments.map(document => {
    if (document.attachment === undefined || document.attachment === null) {
      return (
        <div className={ `${grid.row} ${styles["pending-item"]}` } key={ document.id }>
          <div className={ grid["col-md-8"] }>Untitled Document</div>
          <div className={ grid["col-md-4"] }>{ moment(document.uploaded).format("DD/MM/YYYY") }</div>
        </div>
      );
    }
    return (
      <div className={ `${grid.row} ${styles["pending-item"]}` } key={ document.id }>
        <div className={ grid["col-md-8"] }>{ document.attachment.name }</div>
        <div className={ grid["col-md-4"] }>{ moment(document.uploaded).format("DD/MM/YYYY") }</div>
      </div>
    );
  })
);

PendingDocumentsList.propTypes = {
  pendingDocuments: PropTypes.arrayOf(documentPropType).isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/upload-documents/pending-documents-list.jsx